export enum AdminPermission {
  ADMIN = 'admin',
  ANALYSIS = 'analysis',
  MAILER = 'mailer',
  USER = 'user'
}
